module.exports = __webpack_public_path__ + "img/avatar-1.6c56bd25.png";